import { render, staticRenderFns } from "./SkSpinner.vue?vue&type=template&id=713d4e9e&"
import script from "./SkSpinner.vue?vue&type=script&lang=js&"
export * from "./SkSpinner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports